import { Component, Input, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/app.config.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {
  
  @Input() data :any;
  @Input() contacto :any;
  constructor() { }
  //URL_FILES:string=environment.filesUrl; 
  URL_FILES:string = AppConfigService.config.filesUrl;
  VERSION:string=environment.Version;
  ngOnInit() {
  }

}
